import { nmCryptokit } from './nmCertEnrollment.COFCO';

function BrowserInfo() {
  let res = {
    name: '',
    version: '',
  };
  let reg;
  let userAgent = self.navigator.userAgent;

  if (reg = /edge\/([\d\.]+)/i.exec(userAgent)) {
    res.name = 'Edge';
    res.version = reg[1];
  } else if (/msie/i.test(userAgent)) {
    res.name = 'Internet Explorer';
    res.version = /msie ([\d\.]+)/i.exec(userAgent)[1];
  } else if (/Trident/i.test(userAgent)) {
    res.name = 'Internet Explorer';
    res.version = /rv:([\d\.]+)/i.exec(userAgent)[1];
  } else if (/chrome/i.test(userAgent)) {
    res.name = 'Chrome';
    res.version = /chrome\/([\d\.]+)/i.exec(userAgent)[1];
  } else if (/safari/i.test(userAgent)) {
    res.name = 'Safari';
    res.version = /version\/([\d\.]+)/i.exec(userAgent)[1];
  } else if (/firefox/i.test(userAgent)) {
    res.name = 'Firefox';
    res.version = /firefox\/([\d\.]+)/i.exec(userAgent)[1];
  }
  return res;
}

let CryptoKit;

export function GetCspInfo() {
  return CryptoKit.CFCA_GetCSPInfo();
}


function LoadObj() {
  try {
    let browser = BrowserInfo();
    if ((browser.name == 'Chrome' && parseInt(browser.version) > 41)) {
        // ||
        //     ("Firefox" == browser.name && parseInt(browser.version) > 52)) {

      CryptoKit = new nmCryptokit(browser.name);

      CryptoKit.init()
                .then(() => {
                  console.log('插件已启用！');
                })
                .catch((response) => {
                    // alert(response.result);
                  installExtension();
                });
    } else {
      alert('Unsupported browser!');
    }
  } catch (e) {
        // alert(e);
    return;
  }
}

function installExtension() {
  let browser = BrowserInfo();
  if (browser.name == 'Firefox') {
    let extensionURL = '';
    let xpi = { 'CryptoKit for Firefox': extensionURL };

    InstallTrigger.install(xpi);
  } else if (browser.name == 'Chrome') {
        // alert("Please install extension for Chrome!");
  } else {
    alert('Unsupported browser!');
  }
}

export function OnLoad() {
    // Waiting for extension loading
    // document.getElementById("CryptoKitExtension").style.display = "none";
    // setTimeout(LoadObj(), 500);
  LoadObj();
}

function OnUnLoad() {
  try {
    CryptoKit.uninit().then(() => {
      EnableButton(false);
    });
  } catch (e) {
    alert(e);
    return;
  }
}


function GetSelectedItemIndex(itemName) {
  let ele = document.getElementsByName(itemName);
  for (i = 0; i < ele.length; i++) {
    if (ele[i].checked) {
      return i;
    }
  }
}


function GetCSPInfo() {
  CryptoKit.CFCA_GetCSPInfo()
        .then((response) => {
          document.getElementById('textareaCSPInfo').value = response.result;
        })
        .catch((response) => {
          ShowErrorInfo(response);
        });
}

function GetAllCertInfo() {
  let cspName = document.getElementById('CSPNameList').value;
  CryptoKit.CFCA_GetAllCertInfo(cspName)
        .then((response) => {
          document.getElementById('TextAllCertInfo').value = response.result;
        })
        .catch((response) => {
          ShowErrorInfo(response);
        });
}

export function GetContainer() {
  return CryptoKit.CFCA_GetContainer();
}

let C_keyAlgorithm = 'RSA';
let C_keyLength = 2048;

export function PKCS10Requisition_SingleCert() {
  let strSubjectDN = 'CN=certRequisition,O=CFCA TEST CA,C=CN';

  return CryptoKit.CFCA_GetCSPInfo()
        .then((response) => {
          let result = response.result;
          let csps = result.split('||');
          // let current = csps.filter(f => f.indexOf('Microsoft') == -1);

          // return CryptoKit.CFCA_SetCSPInfo(C_keyLength, current[0]);
          let current = csps.filter(f => f.indexOf('Microsoft') == -1 && ['Uyee CSP v6.0 (Enterprise)', 'CFCA FOR UKEY CSP v1.1.0'].includes(f));

          console.log('current', current);
          if (current.includes('Uyee CSP v6.0 (Enterprise)')) {
            return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'Uyee CSP v6.0 (Enterprise)');
          }
          if (current.includes('CFCA FOR UKEY CSP v1.1.0')) {
            return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'CFCA FOR UKEY CSP v1.1.0');
          }

          return CryptoKit.CFCA_SetCSPInfo(C_keyLength, current[0]);
        })
        .then((response) => { return CryptoKit.CFCA_SetKeyAlgorithm(C_keyAlgorithm); })
        .then((response) => { return CryptoKit.CFCA_PKCS10CertRequisition(strSubjectDN, 1, 0); })
        .then((response) => {
          return Promise.resolve(response.result.replace(/[\r\n]/g, ''));
        });
        // .catch(function (response) {

        //     return CryptoKit.GetLastErrorDesc().then(function (response) {
        //         // console.log(response.result)
        //         throw Error(response.result);
        //     });
        //     voShowErrorInfo(response);
        //     // console.log(response);
        //     // return Promise.reject(response)
        // })
}

function PKCS10Requisition_DoubleCert() {
  let keyAlgorithm = document.getElementById('KenAlgorithm').value;
  let selectValue = document.getElementById('KenLength').value;
  let keyLength = 0;
  if (selectValue == '1024') {
    keyLength = 1024;
  } else if (selectValue == '2048') {
    keyLength = 2048;
  } else if (selectValue == '4096') {
    keyLength = 4096;
  } else {
    keyLength = 256;
  }
  let cspName = document.getElementById('TextCSPName').value;
  if (cspName == '') {
    alert('请选择“生成密钥的CSP名称”');
    FindProvider();
    return;
  }
  let strSubjectDN = document.getElementById('TextSubjectDN').value;

  CryptoKit.CFCA_SetCSPInfo(keyLength, cspName)
        .then((response) => { return CryptoKit.CFCA_SetKeyAlgorithm(keyAlgorithm); })
        .then((response) => { return CryptoKit.CFCA_PKCS10CertRequisition(strSubjectDN, 2, 0); })
        .then((response) => {
          document.getElementById('textareaP10RSASingleCert').value = response.result;
          return CryptoKit.CFCA_GetContainer();
        })
        .then((response) => { document.getElementById('TextContianerName').value = response.result; });
        // .catch(function (response) {
        //     ShowErrorInfo(response);
        // });
}

function KeyAlgorithm_onchange(selectedItemIndex) {
  try {
    let kenLength_select = document.getElementById('KenLength');
    let optionNum = document.getElementById('KenLength').length;
        // remove select's options
    for (let i = optionNum; i >= 0; i--) {
      kenLength_select.remove(i);
    }

    if (selectedItemIndex == 0) {
            // RSA
            // show digest algorithm
      document.getElementById('tr_DigestAlgorithm').style.display = '';

            // key length
      var optionTag = document.createElement('option');
      optionTag.text = '1024';
      optionTag.value = '1024';
      kenLength_select.options.add(optionTag);
      optionTag = document.createElement('option');
      optionTag.text = '2048';
      optionTag.value = '2048';
      kenLength_select.options.add(optionTag);
      optionTag = document.createElement('option');
      optionTag.text = '4096';
      optionTag.value = '4096';
      kenLength_select.options.add(optionTag);
      document.getElementById('TextCSPName').value = 'Microsoft Enhanced Cryptographic Provider v1.0';
    } else {
            // SM2
            // hide digest algorithm
      document.getElementById('tr_DigestAlgorithm').style.display = 'none';

      var optionTag = document.createElement('option');
      optionTag.text = '256';
      optionTag.value = '256';
      kenLength_select.options.add(optionTag);
            // document.getElementById("TextCSPName").value = "CIDC Cryptographic Service Provider v3.0.0";
    }
  } catch (e) {
    alert(e.number + e.message);
  }
}

export function InstallCert(certType, params) {
    // if (params.signCert == "") {
    //     alert("签名公钥证书内容为空");
    //     return;
    // }

    // if (params.containerName == "") {
    //     alert("密钥容器名称内容为空");
    //     return;
    // }

  let { signCert, containerName } = params;

  return CryptoKit.CFCA_GetCSPInfo()
        .then((response) => {
          let result = response.result;
          let csps = result.split('||');
          console.log('csps', csps);
          let current = csps.filter(f => f.indexOf('Microsoft') == -1 && ['Uyee CSP v6.0 (Enterprise)', 'CFCA FOR UKEY CSP v1.1.0'].includes(f));

          console.log('current', current);
          if (current.includes('Uyee CSP v6.0 (Enterprise)')) {
            return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'Uyee CSP v6.0 (Enterprise)');
          }
          if (current.includes('CFCA FOR UKEY CSP v1.1.0')) {
            return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'CFCA FOR UKEY CSP v1.1.0');
          }
          return CryptoKit.CFCA_SetCSPInfo(C_keyLength, current[0]);
        })
        .then((response) => {
          return CryptoKit.CFCA_SetKeyAlgorithm(C_keyAlgorithm);
        })
        // .then(function (response){
        //     return CryptoKit.CFCA_GetContainer()
        // })
        .then((response) => {
          return CryptoKit.CFCA_ImportSignCert(certType, signCert, containerName);
        });
        // .then(function (response) {
        //     return CryptoKit.GetLastErrorDesc().then(function (response) {
        //         return (response);
        //     });
        // })
        // .catch(function (response) {
        //     // ShowErrorInfo(response);
        //     return CryptoKit.GetLastErrorDesc().then(function (response) {
        //         throw Error(response);
        //     });
        // })
}

export function InstallCert2(certType, params) {
  let cspName = document.getElementById('TextCSPName').value;
  if (cspName == '') {
    alert('CSP名称为空');
    return;
  }
  let keyAlgorithm = document.getElementById('KenAlgorithm').value;
  if (keyAlgorithm == '') {
    alert('密钥生成算法为空');
    return;
  }
  let selectValue = document.getElementById('KenLength').value;
  let keyLength = 0;
  if (selectValue == '1024') {
    keyLength = 1024;
  } else if (selectValue == '2048') {
    keyLength = 2048;
  } else if (selectValue == '4096') {
    keyLength = 4096;
  } else if (selectValue == '256') {
    keyLength = 256;
  } else {
    alert('密钥长度错误：' + keyLength);
    return;
  }

  if (params.signCert == '') {
    alert('签名公钥证书内容为空');
    return;
  }

  if (params.containerName == '') {
    alert('密钥容器名称内容为空');
    return;
  }

  CryptoKit.CFCA_SetCSPInfo(keyLength, cspName)
        .then((response) => { return CryptoKit.CFCA_SetKeyAlgorithm(keyAlgorithm); })
        .then((response) => { return CryptoKit.CFCA_ImportSignCert(certType, signCert, containerName); })
        .then((response) => {
          if (certType == 2) {
                // double cert
            let encryptCert_PublickeyCert = document.getElementById('textareaEncryptCert_PublickeyCert').value;
            if (encryptCert_PublickeyCert == '') {
              alert('加密证书公钥证书内容为空');
              return;
            }
            let encryptCert_PrivateData = document.getElementById('textareaEncryptCert_PrivatekeyCert').value;
            if (encryptCert_PrivateData == '') {
              alert('加密证书私钥数据为空');
              return;
            }

            return CryptoKit.CFCA_ImportEncryptCert(encryptCert_PrivateData, encryptCert_PublickeyCert, containerName, 0x1 | 0x2);
          }
        })
        .then((response) => {
          if (certType == 1) {
            alert('单证书安装成功');
          } else {
            alert('双证书安装成功');
          }
        })
        .catch((response) => {
          ShowErrorInfo(response);
        });
}


export function GetVersion() {
  return CryptoKit.CFCA_GetVersion()
        .then((response) => {
          return Promise.resolve(response.result);
        })
        .catch((response) => {
          return Promise.reject();
        });
}

function ShowErrorInfo(response) {
  if (response == null) {
    alert('Extension has been remove!');
  } else if (response.errorcode == 1) { // connection error
    alert(response.result);
  } else { // host error
    console.log(response);
    CryptoKit.GetLastErrorDesc()
            .then((response) => {
              alert(response.result);
            });
  }
}



// WEBPACK FOOTER //
// ./apps/cfcaclass/CrpytoKit.js